<div class="top-contact-bar" [class.hidden]="isSticky">
  <div class="container d-flex justify-content-center align-items-center">
    <a *ngIf="!isMobile" class="navbar-brand font-weight-bold nav-link" routerLink="" (click)="onClickInitHome()">
      <div class="logo-container">
        <img *ngIf="logoUrl==DF_LOGO" class="logo-img" src="{{logoUrl}}">
        <img *ngIf="logoUrl!=DF_LOGO" class="logo-img" [src]="logoUrl">
      </div>
    </a>
    <!-- WhatsApp -->
    <a [href]="'https://wa.me/' + contactPhone + '?text=Hola, vengo desde Softdirex.com me gustaría saber más sobre sus servicios o agendar una reunión'"
      target="_blank" class="contact-item whatsapp">

      <div class="contact-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path
            d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
        </svg>
      </div>
      <div class="contact-content">
        <div class="contact-number">{{contactPhone}}</div>
        <div class="contact-label">WhatsApp</div>
      </div>
    </a>

    <!-- Email -->
    <a [href]="'mailto:' + contactMail" class="contact-item email">
      <div class="contact-icon">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
          <path
            d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z" />
        </svg>
      </div>
      <div class="contact-content">
        <div class="contact-address">{{contactMail}}</div>
        <div class="contact-label">{{'z-custom.send-us-email'|transloco}}</div>
      </div>
    </a>
  </div>
</div>


<nav class="navbar navbar-expand-lg navbar-light w-100 navigation" id="navbar" [ngClass]="{
  'overlay-content': !isSticky,
  'bg-white': isTransparentNavOnScroll && navBarType !== NAVBAR_TYPE_FLOATING,
  'bg-white navbar-bg': navBarType !== NAVBAR_TYPE_TRANSPARENT && navBarType !== NAVBAR_TYPE_FLOATING,
  'sticky': isSticky
  }">
  <div [ngClass]="{
  'container': true
  }">
    <a *ngIf="!withNavBarLogo" class="navbar-brand font-weight-bold nav-link" routerLink=""
      (click)="onClickInitHome()">{{ ownerDetail.company_name
      }}</a>
    <a *ngIf="withNavBarLogo" class="navbar-brand font-weight-bold nav-link" routerLink="" (click)="onClickInitHome()">
      <div class="logo-container">
        <img *ngIf="logoUrl==DF_LOGO && (isMobile || (!isMobile && isSticky))" class="logo-img" src="{{logoUrl}}">
        <img *ngIf="logoUrl!=DF_LOGO && (isMobile || (!isMobile && isSticky))" class="logo-img" [src]="logoUrl">
      </div>
    </a>
    <span *ngIf="envTag !== ''" class="env-tag">{{ envTag }}</span>

    <div *ngIf="isMobile" class="mobile-toggler-group d-flex align-items-center">
      <button *ngIf="langBtnType !== 'none'" class="navbar-toggler" type="button" (click)="openLanguageModal()">
        <i *ngIf="langBtnType === 'default'" class="tf-ion-ios-world"></i>
        <img *ngIf="langBtnType.startsWith('rounded-')" class="rounded-mobile-lang-icon-img"
          [src]="'assets/img/languages/' + getLangSelected() + '.webp'" alt="Lang">
        <img *ngIf="langBtnType.startsWith('square-')" class="square-mobile-lang-icon-img"
          [src]="'assets/img/languages/' + getLangSelected() + '.webp'" alt="Lang">
      </button>

      <button class="navbar-toggler" type="button" (click)="toggleMenu()" (mouseenter)="hoverIcon(true)"
        (mouseleave)="hoverIcon(false)" [attr.aria-expanded]="isMenuOpen" aria-controls="main-navbar"
        aria-label="Toggle navigation">

        <i [ngClass]="{
          'tf-ion-chevron-up': isMenuOpen,
          'tf-ion-chevron-down': isHovered && !isMenuOpen,
          'tf-ion-android-funnel': !isMenuOpen && !isHovered
        }"></i>
      </button>
    </div>

    <div class="navbar-collapse {{navBarAlign !== 'center' ? 'nav-bar-align-' + navBarAlign : ''}}"
      [ngClass]="{'show': isMenuOpen || !isMobile}" id="main-navbar" #mainNavbar>
      <ul class="navbar-nav {{navBarAlign !== 'center' ? '' : 'mx-auto'}}">
        <li class="nav-item" (click)="closeNavbar()">
          <a class="nav-link" routerLink="" (click)="onClickInitHome()">{{'label.home'|transloco}}</a>
        </li>

        <li class="nav-item" (click)="closeNavbar()" *ngIf="showServiceType === VIEW_TYPE_PAGE">
          <a class="nav-link" routerLink="{{PATH_SERVICES}}">{{'label.services'|transloco}}</a>
        </li>

        <li class="nav-item" (click)="closeNavbar()" *ngIf="showServiceType === VIEW_TYPE_HOME">
          <a class="nav-link" routerLink="" (click)="onClickServices()">{{'label.services'|transloco}}</a>
        </li>

        <li class="nav-item" (click)="closeNavbar()" *ngIf="showTeamType === VIEW_TYPE_PAGE">
          <a class="nav-link" routerLink="{{PATH_TEAM}}">{{'label.team'|transloco}}</a>
        </li>

        <li class="nav-item" (click)="closeNavbar()" *ngIf="showTeamType === VIEW_TYPE_HOME">
          <a class="nav-link" routerLink="" (click)="onClickTeam()">{{'label.team'|transloco}}</a>
        </li>

        <li class="nav-item" (click)="closeNavbar()" *ngIf="showAboutUsType === VIEW_TYPE_HOME">
          <a class="nav-link" routerLink="" (click)="onClickAboutUs()">{{'label.about-us'|transloco}}</a>
        </li>

        <li class="nav-item" (click)="closeNavbar()" *ngIf="showContactType === VIEW_TYPE_HOME">
          <a class="nav-link" routerLink="" (click)="onClickContact()">{{'label.contact'|transloco}}</a>
        </li>

        <li class="nav-item" (click)="closeNavbar()" *ngIf="showMapType === VIEW_TYPE_HOME">
          <a class="nav-link" routerLink="" (click)="onClickMap()">{{'label.location'|transloco}}</a>
        </li>

        <li class="nav-item" (click)="closeNavbar()" *ngIf="showPublications === VIEW_TYPE_PAGE">
          <a class="nav-link" routerLink="{{PATH_PUBLICATIONS}}">{{'label.publications'|transloco}}</a>
        </li>

        <li class="nav-item" (click)="closeNavbar()" *ngIf="showGallery === VIEW_TYPE_PAGE">
          <a class="nav-link" routerLink="{{PATH_GALLERY}}">{{'label.gallery'|transloco}}</a>
        </li>

        <li class="nav-item" (click)="closeNavbar()" *ngIf="showAboutUsType === VIEW_TYPE_PAGE">
          <a class="nav-link" routerLink="{{PATH_ABOUT}}">{{'label.about-us'|transloco}}</a>
        </li>

        <li class="nav-item" (click)="closeNavbar()" *ngIf="showMapType === VIEW_TYPE_PAGE">
          <a class="nav-link" routerLink="{{PATH_LOCATION}}">{{'label.location'|transloco}}</a>
        </li>

        <li class="nav-item" (click)="closeNavbar()" *ngIf="showContactType === VIEW_TYPE_PAGE">
          <a class="nav-link" routerLink="{{PATH_CONTACT}}">{{'label.contact'|transloco}}</a>
        </li>

        <!-- Pages -->
        <li *ngIf="isBrowser && isMobile" class="nav-item dropdown dropdown-slide">
          <a *ngIf="isBrowser && sessionIsOpen" class="nav-link dropdown-toggle" id="navbarDropdown4" role="button"
            data-delay="350" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{getCustomerName()}}
          </a>
          <a *ngIf="!sessionIsOpen" class="nav-link dropdown-toggle" id="navbarDropdown4" role="button" data-delay="350"
            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
            {{ 'label.login-invite' | transloco }}
          </a>
          <ul class="dropdown-menu" aria-labelledby="navbarDropdown4">
            <li *ngIf="sessionIsOpen"><a routerLink="{{PATH_MY_CUSTOMER}}"
                (click)="closeNavbar()">{{'label.profile'|transloco}}</a></li>
            <li *ngIf="sessionIsOpen"><a routerLink="{{PATH_PRODUCT}}" class="btn btn-small btn-transparent"
                (click)="closeNavbar()">{{'label.dashboard'|transloco}}</a></li>
            <li *ngIf="sessionIsOpen && !isProduction"><a routerLink="{{PATH_ADMIN_UI_KIT}}"
                class="btn btn-small btn-transparent" (click)="closeNavbar()">UI Kit</a></li>
            <li *ngIf="sessionIsOpen === false"><a routerLink="{{PATH_LOGIN}}" class="btn btn-small btn-main btn-block"
                (click)="closeNavbar()">{{'login.title'|transloco}}</a></li>
            <li *ngIf="!sessionIsOpen && isProductSite"><a routerLink="{{PATH_REGISTER}}"
                class="btn btn-small btn-main btn-block" (click)="closeNavbar()">{{'register.title'|transloco}}</a></li>
            <li *ngIf="!sessionIsOpen && !isProductSite" class="text-center"><br><small>{{appName}}</small></li>
            <li *ngIf="!sessionIsOpen && !isProductSite"><a href="{{PATH_PRODUCT_SITE}}"
                class="btn btn-small btn-default btn-block" target="_blank">{{'label.know-more'|transloco}}</a></li>
            <li *ngIf="sessionIsOpen"><a (click)="closeSession()"
                class="btn btn-small btn-main btn-block">{{'label.close'|transloco}}</a></li>
          </ul>
        </li><!-- /Pages -->

      </ul>
    </div>
    <!-- Navbar-collapse -->

    <ul class="top-menu list-inline mb-0 d-none d-lg-block" id="top-menu">
      <li class="list-inline-item"><a href="#"></a></li>
      <li class="dropdown cart-nav dropdown-slide list-inline-item">
        <a *ngIf="langBtnType === 'default'" (click)="openLanguageModal()" class="dropdown-toggle cart-icon"
          data-toggle="dropdown" data-hover="dropdown">
          <i class="tf-ion-ios-world mr-3"></i>
        </a>
        <a *ngIf="langBtnType === 'rounded-flag'" (click)="openLanguageModal()"
          class="dropdown-toggle cart-icon rounded-lang-selector" data-toggle="dropdown" data-hover="dropdown">
          <img class="rounded-lang-icon-img" [src]="'assets/img/languages/' + getLangSelected() + '.webp'" alt="Lang">
        </a>
        <a *ngIf="langBtnType === 'rounded-detail-flag'" (click)="openLanguageModal()"
          class="dropdown-toggle cart-icon rounded-dt-lang-selector" data-toggle="dropdown" data-hover="dropdown">
          <img class="rounded-dt-lang-icon-img" [src]="'assets/img/languages/' + getLangSelected() + '.webp'"
            alt="Lang">
          <span class="rounded-dt-lang-code-text">{{ getLangSelected() | uppercase }}</span>
        </a>
        <a *ngIf="langBtnType === 'square-flag'" (click)="openLanguageModal()"
          class="dropdown-toggle cart-icon square-lang-selector" data-toggle="dropdown" data-hover="dropdown">
          <img class="square-lang-icon-img" [src]="'assets/img/languages/' + getLangSelected() + '.webp'" alt="Lang">
        </a>
        <a *ngIf="langBtnType === 'square-detail-flag'" (click)="openLanguageModal()"
          class="dropdown-toggle cart-icon square-dt-lang-selector" data-toggle="dropdown" data-hover="dropdown">
          <img class="square-dt-lang-icon-img" [src]="'assets/img/languages/' + getLangSelected() + '.webp'" alt="Lang">
          <span class="square-dt-lang-code-text">{{ getLangSelected() | uppercase }}</span>
        </a>
      </li>

      <li *ngIf="isBrowser" class="dropdown cart-nav dropdown-slide list-inline-item">
        <a class="nav-link dropdown-toggle ml-5" data-toggle="dropdown" data-hover="dropdown">
          {{(sessionIsOpen === true ? 'z-custom.explore' : 'label.start')|transloco}}<i
            [ngClass]="hover ? 'tf-ion-ios-arrow-up' : 'tf-ion-ios-arrow-down'" class="ml-3"></i>
        </a>
        <div class="dropdown-menu cart-dropdown">
      <li *ngIf="sessionIsOpen">
        <h3>{{getCustomerName()}}</h3>
      </li>
      <li *ngIf="sessionIsOpen"><a routerLink="{{PATH_MY_CUSTOMER}}">{{'label.profile'|transloco}}</a></li>
      <!--li *ngIf="sessionIsOpen"><a href="user/orders">Orders</a></li>
          <li *ngIf="sessionIsOpen"><a href="user/favorites">My favorites</a></li-->
      <li *ngIf="sessionIsOpen"><a routerLink="{{PATH_PRODUCT}}"
          class="btn btn-small btn-transparent">{{'label.dashboard'|transloco}}</a></li>
      <li *ngIf="sessionIsOpen && !isProduction"><a routerLink="{{PATH_ADMIN_UI_KIT}}"
          class="btn btn-small btn-transparent">UI Kit</a></li>
      <li *ngIf="sessionIsOpen && enableWebmailSiteLink"><a href="{{webmailSite}}" target="_blank"
          class="btn btn-small btn-transparent">{{'label.open-mail-site'|transloco}}</a></li>
      <div *ngIf="sessionIsOpen === false" class="text-center cart-buttons mt-3">
        <a (click)="openLanguageModal()" class="dropdown-toggle btn btn-small btn-main-transparent btn-block"
          data-toggle="dropdown" data-hover="dropdown">
          {{'language.title'|transloco}}
        </a>
      </div>
      <div *ngIf="sessionIsOpen === false" class="text-center cart-buttons mt-3">
        <a href="{{PATH_STORE}}" target="_blank"
          class="btn btn-small btn-main-transparent btn-block">{{'label.store'|transloco}}</a>
      </div>
      <div *ngIf="sessionIsOpen === false" class="text-center cart-buttons mt-3">
        <a href="{{PATH_EE_REGISTER}}"
          class="btn btn-small btn-main-transparent btn-block">{{'register.title'|transloco}}</a>
      </div>
      <div *ngIf="sessionIsOpen === false" class="text-center cart-buttons mt-3">
        <a routerLink="{{PATH_LOGIN}}" class="btn btn-small btn-main btn-block">{{'login.title'|transloco}}</a>
      </div>
      <div *ngIf="!sessionIsOpen && isProductSite" class="text-center cart-buttons mt-3">
        <a routerLink="{{PATH_REGISTER}}" class="btn btn-small btn-main btn-block">{{'register.title'|transloco}}</a>
      </div>
      <div *ngIf="sessionIsOpen" class="text-center cart-buttons mt-3">
        <a routerLink="{{PATH_DOCS}}"
          class="btn btn-small btn-transparent btn-block">{{'z-custom.documentation'|transloco}}</a>
        <a href="{{PATH_SERVICE_STATUS_ADMIN}}" target="_blank"
          class="btn btn-small btn-transparent btn-block">{{'label.service-status-admin'|transloco}}</a>
      </div>
      <div *ngIf="sessionIsOpen" class="text-center cart-buttons mt-3">
        <a (click)="closeSession()" class="btn btn-small btn-main btn-block">{{'label.close'|transloco}}</a>
      </div>
  </div>
  </li>
  </ul>
  </div>
</nav>
